import {baseDataService} from "@/services/baseData.service";

export const state = {
    selectedCustomer:{},
    items:[] ,
    offlineOrders:[]
}


export const actions = {
    async createSalesOrder({state, commit}) {
        try { 
            let DetailsLines = state.items.map(x=>{
                                            let row = {"productid":x.productid,"quantity":x.quantity};
                                            let product = JSON.parse(localStorage.getItem(x.productid));
                                            if(product){ 
                                                row.Price =product.Price;   
                                            }
                                            return row;
                                        });
            let order = await baseDataService.createSalesOrder(state.selectedCustomer.idCustomerMaster,DetailsLines);
             
            if(order.OK=="OK"){
                this.commit("shoppyCart/_clearCart");
            }            
            return order;
        } catch (error) {
            commit('offlineOrder');   
            return {"OK":"NOK",message:"off line"};         
        } 
    }
}

export const mutations = {
    loadCustomer(state){
        let customer = JSON.parse(localStorage.getItem("cart_active_customer"));
        if(customer){
            state.selectedCustomer =customer;
            return;
        }
        state.selectedCustomer=null;
    },
    loadItems(state){
        let items = JSON.parse(localStorage.getItem("cart_items"));
        if(items){
            state.items =items;
            return;
        }
        state.items =[];
    },
    loadOfflineOrders(state){
        state.offlineOrders =[];
        let offlineList = JSON.parse(localStorage.getItem("offline"));
        if(!offlineList){
            offlineList = [];
        }
        offlineList.forEach(element => {
            let offlineOrder = JSON.parse(localStorage.getItem(element));
            if(offlineOrder){
                offlineOrder.key = element;
                offlineOrder.Name = offlineOrder.customer.Name;
                offlineOrder.Items = offlineOrder.items.length;
                state.offlineOrders.push(offlineOrder);
            }
        });
    },
    convertOfflineToCart(state,Index){
        let key = state.offlineOrders[Index].key;
        let offLineData = JSON.parse(localStorage.getItem(key));

        state.selectedCustomer =offLineData.customer;
        state.items = offLineData.items;
        localStorage.removeItem(key);

        state.offlineOrders.splice(Index,1);
        let allKeys = state.offlineOrders.map(x=>x.key);
        localStorage.setItem("offline",JSON.stringify(allKeys));
        this.commit("shoppyCart/_saveItemState") 
    },
    setCustomer(state,customer){
        state.selectedCustomer =customer;
        localStorage.setItem("cart_active_customer",JSON.stringify(customer));
    },
    addItem(state,Product){
        state.items.push(Product);
        this.commit("shoppyCart/_saveItemState") 
    },
    deleteItem(state,Index){
        state.items.splice(Index,1);
        this.commit("shoppyCart/_saveItemState") 
    },
    updateItem(state,args){        
        if(args[1]){
            state.items[args[0]] = args[1];
        }        
        this.commit("shoppyCart/_saveItemState") 
    },
    _clearCart(state){
        state.selectedCustomer=null;
        state.items =[];
        this.commit("shoppyCart/_saveItemState");
        this.commit("productView/clear");
    },
    _saveItemState(state){
        localStorage.setItem("cart_items",JSON.stringify(state.items));
        localStorage.setItem("cart_active_customer",JSON.stringify(state.selectedCustomer));
    },
    offlineOrder(state){
        let offlineOrder = {"customer":state.selectedCustomer,"items":state.items}
        let key = "offline_"+state.selectedCustomer.idCustomerMaster;
        localStorage.setItem(key,JSON.stringify(offlineOrder));
        let listOfOfflineOrder = JSON.parse(localStorage.getItem("offline"));
        if(!listOfOfflineOrder){
            listOfOfflineOrder = [];
        }
        listOfOfflineOrder.push(key);
        localStorage.setItem("offline",JSON.stringify(listOfOfflineOrder));
        
        this.commit("shoppyCart/_clearCart") 
    }
}